<template>
  <el-select clearable :value="value" @input="updateValue" placeholder="请选择教练" @clear="updateValue(undefined)">
    <el-option
      v-for="item in coachs"
      :key="item.uid"
      :label="item.name"
      :value="item.uid">
    </el-option>
  </el-select>
</template>
<script>
export default {
  data () {
    return {
      coachs: []
    }
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      var that = this
      this.api.coach.all({}).then(function (response) {
        if (response.data.success) {
          that.coachs = response.data.result
        }
      })
    },
    updateValue (val) {
      this.$emit('input', val)
    }
  },
  props: {
    value: { required: true }
  }
}
</script>



// WEBPACK FOOTER //
// CoachSelect.vue?6ae14449